// extracted by css-extract-rspack-plugin
export default {"header":"_f93db1ef"};